import React, { useContext } from 'react';

import { auth } from "../config/firebase";

import { DataContext } from '../components/data/DataContext';
import { DataContextType } from '../components/data_types/interfaces';

import { rebuildDB } from '../cache/match_data';

import { Typography } from '@mui/material';

import MinimalLayoutWrapper from '../components/shared/MinimalLayoutWrapper';


const RefreshData = () => {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { currentSeason } = context || {};
    const currentUser = auth.currentUser;

    const uid = currentUser!.uid;

    if (uid && currentSeason) {
        rebuildDB(currentSeason, uid);
    }

    return (
        <MinimalLayoutWrapper>
            <Typography component="h1" variant="h6" sx={{ m: 0 }}>
                One Moment: Your metrics are refreshing
            </Typography>
        </MinimalLayoutWrapper>
    );
};

export default RefreshData;
